import { render, staticRenderFns } from "./ProductAbout.vue?vue&type=template&id=25029f64&scoped=true&"
import script from "./ProductAbout.vue?vue&type=script&lang=ts&"
export * from "./ProductAbout.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAbout.vue?vue&type=style&index=0&id=25029f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25029f64",
  null
  
)

export default component.exports